var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
import { TextField } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
export var MyButton = styled(IconButton)(function (props) { return ({
    '&&': {
        color: props.customColor
    }
}); });
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 5px;\n  padding: 15px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 5px;\n  padding: 15px;\n"])));
export var TitleWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 0px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 0px;\n"])));
export var CustomTextField = styled(TextField)({
    '&&': {
        width: 300
    }
});
export var GridWrapper = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n  height: 100%;\n"])));
export var ListItemWrapper = styled('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=CampaignOversightListTable.Styles.js.map